module.exports = __webpack_public_path__ + "static/media/leaderboard.11a2cde2.svg";